import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import Hexagon from "../hexagon";



export const ButtonContainer = styled.div`
    height: 100%;
    width: 100%;

    max-height: 4rem;
    max-width: 4rem;

`;

export const TimesIcon = styled.div`
    height: inherit;
    width: inherit;
    
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const IconOverlay = styled(FontAwesomeIcon)`
    color: white;
    font-size: 1.625rem;
    filter: drop-shadow(1px 1px 1px #777);
`;
export default class EndButton extends Component {
    static propTypes = {
        onClick: PropTypes.func
    }

    render() {
        const { onClick, size, common, title } = this.props;
        return (
            <ButtonContainer onClick={onClick}>
                <TimesIcon>
                    <Hexagon common={common} icon={faTimes} title={title} />
                </TimesIcon>
            </ButtonContainer>
        )
    }
}
